import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
})
export class DefaultFooterComponent extends FooterComponent {
  expanded = false;
  version: string = environment.version;
  currentYear: number = new Date().getFullYear();

  constructor() {
    super();
  }

  showDisclaimer() {
    this.expanded = !this.expanded;
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }, 0);
  }
}
